import { RatingProps, Rating as StarRating } from 'react-simple-star-rating';

export const Rating = ({ size = 25, ...props }: RatingProps) => {
  return <StarRating size={size} {...props} />;
};

export type { RatingProps };
